// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__A1HDY","form__label":"ContactForm_form__label__qerRv","form__item":"ContactForm_form__item__wyFZ6"};